module.exports = __webpack_public_path__ + "img/businessAd_red.1de8fa80.png";